var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 150,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#062F6D",
    d: "M0 0h375v150H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M79.588 85.385c-31.46.616-66.48 11.94-79.588 21.956V150h375V85c-25.281 16.948-66.573 26.655-87.547 28.504-26.217 2.311-65.543-4.237-95.037-11.556-29.495-7.318-73.502-17.333-112.828-16.563Z",
    fill: "#A4B2CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M295.412 49.505c31.461.746 66.479 14.463 79.588 26.594V150H0V70.5c25.28 20.529 66.573 32.286 87.547 34.526 26.217 2.799 65.543-5.133 95.037-13.997 29.495-8.865 73.502-42.457 112.828-41.524Z",
    fill: "#A4B2CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBg);
export default __webpack_public_path__ + "static/media/profile-bg.ac7ce67ce161772315ac104ae8d1ee27.svg";
export { ForwardRef as ReactComponent };